import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[autoClick]',
  standalone: true,
})
export class AutoClickDirective implements OnInit {
  @Input() autoClick: boolean = false;
  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.autoClick) {
      this.el.nativeElement.click();
    }
  }
}
